import { Report } from "../../containers/Report"
import { ReportContextProvider } from "../../contexts/ReportContext"

export function IncidentAnalysePage() {
    return (
        <ReportContextProvider>
            <Report />
        </ReportContextProvider>
    )
}